import objectAssign from 'object-assign';
import initialState from './initialState';
import { 
  UPDATE_CARD_NUMBER,
  UPDATE_EXPIRY_DATE,
  UPDATE_CVC,
  CREATE_PAYMENT_REQUEST,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  UPDATE_PAYMENT_REQUEST,
  UPDATE_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_FAILURE,
  GET_PAYMENT_DETAILS_REQUEST,
  GET_PAYMENT_DETAILS_FAILURE,
  GET_PAYMENT_DETAILS_SUCCESS,
  RESET_PAYMENT_DETAILS
  
 } from '../constants/actionTypes';

 export default function pricingReducer(state = initialState.paymentDetail, action) {

    switch (action.type) {
      
      case UPDATE_CARD_NUMBER:
        return objectAssign({}, state, { cardNumber: action.cardNumber });
      case UPDATE_EXPIRY_DATE:
        return objectAssign({}, state, { expiryDate:action.expiryDate});
      case UPDATE_CVC: {
        return objectAssign({}, state, {cvc:action.cvc });
        
      }
      case CREATE_PAYMENT_REQUEST:
        return objectAssign({}, state, { isFetching:true  });
      case CREATE_PAYMENT_SUCCESS:
        return objectAssign({}, state, 
          { 
            isFetching:false
          });
      case CREATE_PAYMENT_FAILURE:
        return objectAssign({}, state, { isFetching:false });
        case UPDATE_PAYMENT_REQUEST:
        return objectAssign({}, state, { isFetching:true  });
      case UPDATE_PAYMENT_SUCCESS:
        return objectAssign({}, state, 
          { 
            isFetching:false
          });
      case UPDATE_PAYMENT_FAILURE:
        return objectAssign({}, state, { isFetching:false,error:action.error });
        
        case GET_PAYMENT_DETAILS_REQUEST:
          return objectAssign({}, state, { isFetching: true });
        case GET_PAYMENT_DETAILS_FAILURE:
          return objectAssign({}, state, { isFetching: false, error: action.error});
        case GET_PAYMENT_DETAILS_SUCCESS: {

          return objectAssign({}, state, { 
            isFetching: false,
            validated:action.data.cardNumber!='',
            cardNumber:action.data.cardNumber?action.data.cardNumber:'',
            expiryDate:action.data.expiryDate,
            data: action.data});
        }
        case RESET_PAYMENT_DETAILS:{
          return objectAssign({}, state, { 
            isFetching: false,
            validated:false,
            cardNumber:'',
            expiryDate:'',
            cvc:'',
            data: {}
          });
        }

    
      
          
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/reducers/paymentDetailReducer.js